/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cook_Step_IngredientsInputs */

const en_cook_step_ingredients = /** @type {(inputs: Cook_Step_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients for this step`)
};

const de_cook_step_ingredients = /** @type {(inputs: Cook_Step_IngredientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten für diesen Schritt`)
};

/**
* | output |
* | --- |
* | "Ingredients for this step" |
*
* @param {Cook_Step_IngredientsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cook_step_ingredients = /** @type {((inputs?: Cook_Step_IngredientsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cook_Step_IngredientsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cook_step_ingredients(inputs)
	return en_cook_step_ingredients(inputs)
});